// @view/panels/workspace/FeedbackSuccessModal.panel.tsx
import React from "react";
import type { FeedbackSuccessModalPhase } from "@ps-bridge/models/ui/feedbackSuccessModalPhase";
import type { FeedbackSubmissionViewProps } from "@ps-bridge/contracts/feedbackSubmission";
import FeedbackSuccessModalHiddenView from "@view/workspace/FeedbackSuccessModalHidden.view";
import FeedbackSuccessModalVisibleView from "@view/workspace/FeedbackSuccessModalVisible.view";

type FeedbackSuccessModalPanelProps = { phase: FeedbackSuccessModalPhase; } & Pick<FeedbackSubmissionViewProps, "onBackToHome" | "onCloseSuccessModal">;

const FeedbackSuccessModalPanel: React.FC<FeedbackSuccessModalPanelProps> = (props) => {
  const { phase, ...viewProps } = props;
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<FeedbackSuccessModalPhase, FeedbackSuccessModalPhase>;
  const render = {
    [phaseKeys.hidden]: <FeedbackSuccessModalHiddenView />,
    [phaseKeys.visible]: <FeedbackSuccessModalVisibleView {...viewProps} />,
  } as const satisfies Record<FeedbackSuccessModalPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(FeedbackSuccessModalPanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase;
});
